export const routerConfig = [
    {
        path:'/:lang/',
        component: () => import('@/views/home/index'),
        name: 'index',
        meta: { 
          title: 'KAMS LED - Professional Commercial Lighting Manufacturer',
          seo: {
            title: 'KAMS LED - Premium Commercial Lighting Solutions',
            description: 'High-quality commercial LED lighting manufacturer with global projects experience since 2009.',
            keywords: 'led strip lights',
            image: '/images/og-home.jpg'
          },
          icon: 'dashboard', 
          affix: true,
          breadcrumb: { label: 'message.language_33' } // 首页
        }
      },
      
      // 产品主路由
      {        path:'/:lang/products/productDetails/detail',
        component: () => import('@/views/products/productDetails/details/index.vue'),
        name: 'productsExtendedDetail',
        meta: {
          title: 'Product Details - KAMS LED',
          seo: {
            title: 'Product Details - KAMS LED',
            description: 'Detailed specifications and features of our premium LED lighting products.',
            keywords: 'product details, LED specifications, lighting features, commercial lighting',
            image: '/images/og-product-detail.jpg'
          },
          icon: 'dashboard',
          affix: true,
          breadcrumb: {
            label: (route) => route.query.title || 'Product Detail',
            parent: 'products'
          }
        }
      },
      {
        path:'/:lang/products',
        component: () => import('@/views/products/index'),
        name: 'products',
        meta: { 
          title: 'Products - KAMS LED Lighting Solutions',
          seo: {
            title: 'Products - KAMS LED Lighting Solutions',
            description: 'Explore our premium LED lighting products including downlights, track lights and strip lights.',
            keywords: 'LED products, downlights, track lights, strip lights, commercial lighting',
            image: '/images/og-products.jpg'
          },
          icon: 'dashboard', 
          affix: true,
          breadcrumb: { label: 'message.language_1' }, // 产品
        }
      },
      {           path:'/:lang/products/product/detail',
                component: () => import('@/views/products/detail/index'),
                name: 'productDetail',
                meta: { 
                  title: 'Product Category - KAMS LED',
                  seo: {
                    title: 'Product Categories - KAMS LED Lighting',
                    description: 'Browse our comprehensive range of commercial LED lighting products and solutions.',
                    keywords: 'product categories, LED lighting types, commercial lighting options',
                    image: '/images/og-product-category.jpg'
                  },
                  icon: 'dashboard', 
                  affix: true 
                },
      },
      {
        path:'/:lang/products/detail',
        component: () => import('@/views/products/product/detail/index'),
        name: 'productsSubDetail',
        meta: {
          title: 'Product Details - KAMS LED',
          seo: {
            title: 'Product Details - KAMS LED',
            description: 'Detailed specifications and features of our premium LED lighting products.',
            keywords: 'product details, LED specifications, lighting features',
            image: '/images/og-product-detail.jpg'
          },
          icon: 'dashboard',
          affix: true,
          breadcrumb: {
            label: (route) => route.query.title || 'Product Detail',
            parent: 'products'
          }
        }
      },
      // 产品相关路由已重构为嵌套结构
      {path:'/:lang/project',
        component: () => import('@/views/products/project/index.vue'),
        name: 'project',
        meta: { 
          title: 'Projects - KAMS LED Case Studies',
          seo: {
            title: 'Our Projects - KAMS LED Lighting Solutions',
            description: 'Explore our successful LED lighting projects and case studies worldwide.',
            keywords: 'LED projects, case studies, lighting installations',
            image: '/images/og-projects.jpg'
          },
          icon: 'dashboard', 
          affix: true,
          breadcrumb: { label: 'message.language_2' } // Projects
        },
        children: [
          // 项目详情页面
          
        ]
      },
      {
            path: '/:lang/project/details',
            component: () => import('@/views/products/project/projectDetails/index.vue'),
            name: 'projectDetail',
            meta: {
              title: 'Project Details Page',
              icon: 'dashboard',
              affix: true,
              breadcrumb: {
                label: (route) => route.query.projectName || 'Project Details',
                parent: 'project'
              }
            }
      },
      {
        path:'/:lang/pdf/prew',
        component: () => import('@/views/pdf/prew.vue'),
        name: 'prew',
        meta: { title: 'PDF Preview', icon: 'dashboard', affix: true,hideHeader: true, hideFooter: true},
      },
      { 
        path:'/:lang/downloads',
        component: () => import('@/views/products/downloads/index.vue'),
        name: 'downloads',
        meta: { title: 'Download', icon: 'dashboard', affix: true, breadcrumb: { label: 'message.language_6' } },
      },
      { 
        path:'/:lang/news',
        component: () => import('@/views/products/news/index.vue'),
        name: 'news',
        meta: { 
          title: 'News - KAMS LED Updates',
          seo: {
            title: 'Latest News - KAMS LED Lighting',
            description: 'Stay updated with the latest news and developments from KAMS LED lighting solutions.',
            keywords: 'LED news, lighting industry updates, commercial lighting trends',
            image: '/images/og-news.jpg'
          },
          icon: 'dashboard', 
          affix: true,
          breadcrumb: { label: 'message.language_3' } // News
        },
       
      },
      {
            path: '/:lang/news/details',
            component: () => import('@/views/products/news/newsDetails/index.vue'),
            name: 'newsDetails',
            meta: {
              title: 'News Details Page',
              icon: 'dashboard',
              affix: true,
              breadcrumb: {
                label: (route) => route.query.title || 'News Details',
                parent: 'news'
              }
            }
      },
      {        path:'/:lang/custom',
        component: () => import('@/views/products/custom/index.vue'),
        name: 'custom',
        meta: { title: 'Customization', icon: 'dashboard', affix: true, breadcrumb: { label: 'message.language_7' } },
      },
      {        path:'/:lang/company',
        component: () => import('@/views/products/company/index.vue'),
        name: 'company',
        meta: { 
          title: 'About KAMS LED - Professional Lighting Manufacturer',
          seo: {
            title: 'About Us - KAMS LED Lighting Solutions',
            description: 'Learn about KAMS LED - a professional commercial lighting manufacturer with global experience since 2009.',
            keywords: 'about KAMS, LED manufacturer, company profile, lighting expertise',
            image: '/images/og-company.jpg'
          },
          icon: 'dashboard', 
          affix: true,
          breadcrumb: { label: 'message.language_4' } // About Us
        },
        children: [
          // 可以在这里添加公司相关的子页面
        ]
      },
      {        path:'/:lang/videos',
        component: () => import('@/views/products/videos/index.vue'),
        name: 'videos',
        meta: { title: '视频专区', icon: 'dashboard', affix: true, breadcrumb: { label: 'message.language_8' } },
      },
      {        path:'/:lang/contact',
        component: () => import('@/views/products/contact/index.vue'),
        name: 'contact',
        meta: { title: '联系我们', icon: 'dashboard', affix: true, breadcrumb: { label: 'message.language_5' } },
      },
      {
        path:'/:lang/createPdf',
        component: () => import('@/views/pdf/index.vue'),
        name: 'createPdf',
        meta: { title: '非标规格书生成', icon: 'dashboard', affix: true },
      },
      {
        path:'/:lang/projectApplication',
        component: () => import('@/views/pdf/index.vue'),
        name: 'projectApplication',
        meta: { title: '非标规格书生成', icon: 'dashboard', affix: true },
      },
      {        path:'/:lang/search',
        component: () => import('@/views/products/search/index.vue'),
        name: 'Search',
        meta: { title: 'Search', icon: 'dashboard', affix: true },
      },
      {        path:'/:lang/products/qrcode',
        component: () => import('@/views/products/qrcode/index.vue'),
        name: 'qrcode',
        meta: { 
          title: 'Contact Page', 
          icon: 'dashboard', 
          affix: true,
          hideHeader: true,
          hideFooter: true,
          hideWhatsApp: true,
          seo: {
            title: 'Contact Page - KAMS LED',
            description: 'View contact page for KAMS LED representatives.',
            keywords: 'contact page, KAMS LED, lighting manufacturer',
            image: '/images/og-contact.jpg'
          },
          breadcrumb: {
            label: 'Contact Page',
            parent: 'products'
          }
        },
      },
      {
        path:'/:lang/personalCenter',
        component: () => import('@/views/personal/index.vue'),
        name: 'PersonalCenter',
        meta: { title: 'Personal Center', icon: 'dashboard', affix: true },
        children: [
          {
            path: 'profile',
            component: () => import('@/views/personal/pages/Profile.vue'),
            name: 'Profile',
            meta: { title: 'Profile', icon: 'dashboard', affix: true },
          },
          {
            path: 'history',
            component: () => import('@/views/personal/pages/SpecHistory.vue'),
            name: 'SpecHistory',
            meta: { title: 'Spec History', icon: 'dashboard', affix: true },
          },
          {
            path: 'security',
            component: () => import('@/views/personal/pages/Security.vue'),
            name: 'Security',
            meta: { title: 'Security', icon: 'dashboard', affix: true },
          },
          {
            path: 'template',
            component: () => import('@/views/personal/pages/Template.vue'),
            name: 'Template',
            meta: { title: 'Template', icon: 'dashboard', affix: true },
          },
          {
            path: 'favorites',
            component: () => import('@/views/personal/favorites/index.vue'),
            name: 'Favorites',
            meta: { title: 'My Favorites', icon: 'dashboard', affix: true },
          },
          {
            path: 'projects',
            component: () => import('@/views/personal/projects/index.vue'),
            name: 'Projects',
            meta: { title: 'Project Management', icon: 'dashboard', affix: true },
          },
          {
            path: 'inquiryHistory',
            component: () => import('@/views/personal/pages/InquiryHistory.vue'),
            name: 'InquiryHistory',
            meta: { title: 'Inquiry History', icon: 'dashboard', affix: true },
          },
          {
            path: 'quoteHistory',
            component: () => import('@/components/QuoteHistory'),
            name: 'QuoteHistory',
            meta: { title: 'Quote History', icon: 'document-copy', affix: true },
          },
        ]
      },
      {
        path:'/:lang/favorites',
        component: () => import('@/views/personal/favorites/index.vue'),
        name: 'FavoritesPage',
        meta: { title: 'My Favorites', icon: 'dashboard', affix: true },
      },
      {
        path:'/:lang/privacy-policy',
        component: () => import('@/views/policy/privacyPolicy.vue'),
        name: 'privacy-policy',
        meta: { title: 'privacy-policy', icon: 'dashboard', affix: true },
      },
      {        
        path:'/:lang/terms-of-service',
        component: () => import('@/views/terms/index.vue'),
        name: 'terms-of-service',
        meta: { title: 'terms-of-service', icon: 'dashboard', affix: true },
      },
      // 测试页面（仅开发环境）
      {
        path:'/:lang/test/language',
        component: () => import('@/views/test/LanguageTest.vue'),
        name: 'language-test',
        meta: { title: 'Language Test', icon: 'dashboard', affix: true },
      },
      {
        path:'/:lang/test/language-debug',
        component: () => import('@/views/test/LanguageDebugTest.vue'),
        name: 'language-debug-test',
        meta: { title: 'Language Debug Test', icon: 'dashboard', affix: true },
      },
]
